module.exports = __webpack_public_path__ + "static/media/score_result_2.10407d73.png";